import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-brand-contract",
  "use": "icon-soc-l1-brand-contract-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-l1-brand-contract\">\n  <!-- ????????????? + ?? -->\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path d=\"M256 192h448c35 0 64 29 64 64v512c0 35-29 64-64 64H256c-35 0-64-29-64-64V256c0-35 29-64 64-64z\" />\n    <path d=\"M352 352h320M352 480h320M352 608h160\" />\n    <circle cx=\"704\" cy=\"704\" r=\"112\" />\n    <circle cx=\"704\" cy=\"704\" r=\"40\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-brand-contract.svg
// module id = AJKZ
// module chunks = 491